import { useClearSessionStateCache } from "@lending/hooks/queries/useGetSessionQuery";
import { $baseApi } from "@lending/lib/api";

function useCreateAutoLoanApplicationQuery() {
  // A successful create mints the lending session cookie, so the cached
  // session-state probe (which gates the account menu) must be refreshed.
  const clearSessionStateCache = useClearSessionStateCache();

  return $baseApi.useMutation("post", "/v2/lending/vehicle_loan_applications/", {
    onSuccess: () => clearSessionStateCache(),
  });
}

export { useCreateAutoLoanApplicationQuery };
